import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { propertySaveService } from '../../../services/propertySaveService'
import { propertiesService } from '../../../services/propertiesService'
import {
  ADD_PRODUCT_MACRO_ELEMENTS,
  ADD_PRODUCT_MICRO_ELEMENTS,
  ADD_PRODUCT_PHYSICAL_PROPERTIES,
} from '../../helper'
import SelectWithoutTokens from '../../../shared/SelectWithoutTokens'

type SelectOption = {
  id: string
  name: string
}

const PropertyItemCategory = () => {
  const { i18n } = useTranslation()
  const [propertyCategory, setPropertyCategory] = useState(
    () => propertySaveService.getProperty().categoryName || '',
  )

  const makeCategoryNamesList = (): SelectOption[] => [
    {
      name: i18n.t(
        propertiesService.getPropertyCategoryi18nCode({
          categoryName: ADD_PRODUCT_MACRO_ELEMENTS,
        }),
      ),
      id: ADD_PRODUCT_MACRO_ELEMENTS,
    },
    {
      name: i18n.t(
        propertiesService.getPropertyCategoryi18nCode({
          categoryName: ADD_PRODUCT_MICRO_ELEMENTS,
        }),
      ),
      id: ADD_PRODUCT_MICRO_ELEMENTS,
    },
    {
      name: i18n.t(
        propertiesService.getPropertyCategoryi18nCode({
          categoryName: ADD_PRODUCT_PHYSICAL_PROPERTIES,
        }),
      ),
      id: ADD_PRODUCT_PHYSICAL_PROPERTIES,
    },
  ]

  const getPropertyCategoryTitle = (category: string): string => {
    if (!category) {
      return ''
    }
    return i18n.t(
      propertiesService.getPropertyCategoryi18nCode({ categoryName: category }),
    )
  }

  const changePropertyCategory = (property: SelectOption) => {
    propertySaveService.updatePropertyValue('categoryName', property.id)
  }

  const changePropertyState = () => {
    setPropertyCategory(propertySaveService.getProperty().categoryName || '')
  }

  useEffect(() => {
    changePropertyState()
    propertySaveService.registerItemUpdateObserver(changePropertyState)
    return () =>
      propertySaveService.unRegisterItemUpdateObserver(changePropertyState)
  }, [])

  return (
    <label
      className="block__text product__form-label"
      key={`${propertyCategory}label`}
    >
      <span className="product__form-label_text">
        {i18n.t('app.page.product.propertyItem.categoryName')}
      </span>
      <SelectWithoutTokens
        listOfOptions={makeCategoryNamesList()}
        handleChangeValue={changePropertyCategory}
        titleValue={getPropertyCategoryTitle(propertyCategory)}
      />
    </label>
  )
}

export default PropertyItemCategory
